<template>
  <div>
    <h6
      style="font-weight: 400; margin: 0px !important; padding: 0px !important"
    >
      {{ VALUE.name }}
    </h6>
  </div>
</template>
<script>
export default {
  data() {
    return {
      VALUE: ""
    };
  },
  created() {
    this.VALUE = {
      name:
        this.params.value == 900
          ? "Mamül"
          : this.params.value == 901
          ? "Yarı Mamül"
          : this.params.value == 902
          ? "Ham Madde"
          : this.params.value == 903
          ? "Diğer"
          : this.params.value == 906
          ? "Yardımcı Malzeme"
          : "Sarf Malzeme",
      val: this.params.value
    };
  }
};
</script>
